import { useLoaderData } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { useTitle } from '../../../../../common/hooks/useTitle.js';
import { myOrdersMsg, omaElisaForEmployeeMsg, t } from '../../../../../common/i18n/index.js';
import {
  EoeMyOrdersBreadcrumb,
  EoeMyOrdersNavi,
} from '../../../../../components/EoeMyOrdersWrapper/EoeMyOrdersWrapper.js';
import { Grid } from '../../../../../components/Grid/Grid.js';
import { RedeemRequestList } from '../../../../../components/SubscriptionAction/RedeemRequestList';
import { useAuth } from '../../../AuthProvider';
import type { SubscriptionActionsResponse } from '../../../../../generated/api/subscriptionActionsResponse';

export const EoeOwnChangeRequestsPath = () => {
  const { authenticatedUser } = useAuth();
  const { searchResults, total } = useLoaderData() as SubscriptionActionsResponse;

  useTitle([t.H6JV(omaElisaForEmployeeMsg), t.EG6F(myOrdersMsg)]);

  return (
    <>
      <EoeMyOrdersBreadcrumb />
      <EoeMyOrdersNavi />
      <Grid>
        <RedeemRequestList
          basePath={paths.EMPLOYEE_OWN_CHANGE_REQUEST}
          redeemRequests={searchResults}
          totalItems={total}
          authenticatedUser={authenticatedUser}
        />
      </Grid>
    </>
  );
};
